"use client";

import { useMedia } from "@/hooks/system/useMedia";
import S from "./index.module.scss";
import { AWARDS, AwardType } from "@/views/home/constants/awards";
import CustomIcon from "@/components/ui/custom-icon";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import { CSSProperties } from "react";
import clsx from "clsx";

const AwardsDesktop = () => {
  return (
    <div className={S.desktopAwards}>
      {AWARDS.map((group, idx) => (
        <div className={S.groupWrapper} key={idx}>
          {group.group.map((award, awardsIdx) => (
            <div key={awardsIdx} className={S.award}>
              {award.type === "icon" ? (
                <div className={S.awardIcon} style={{ "--icon-height": `${award.height}px` } as CSSProperties}>
                  <CustomIcon fileName={award.src} />
                </div>
              ) : (
                <span className={S.awardText}>{award.title}</span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const AwardsMobile = () => {
  const awards = AWARDS.reduce((acc, group) => {
    return [...acc, ...group.group];
  }, [] as AwardType[]);

  return (
    <div>
      <Swiper
        loop
        freeMode
        modules={[Autoplay, FreeMode]}
        speed={3000}
        slidesPerView={"auto"}
        className={S.swiperWrapper}
        autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false }}
      >
        {awards.map((award, idx) => (
          <SwiperSlide className={clsx(S.awardSlide, award.type === "text" && S["awardSlide--end"])} key={idx}>
            {award.type === "icon" ? (
              <div className={S.awardIcon} style={{ "--icon-height": `${award.height}px` } as CSSProperties}>
                <CustomIcon fileName={award.src} />
              </div>
            ) : (
              <span className={S.awardText}>{award.title}</span>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const Awards = () => {
  const { isDesktop, isClient } = useMedia();

  return <div className={S.awardsWrapper}>{isDesktop && isClient ? <AwardsDesktop /> : <AwardsMobile />}</div>;
};

export default Awards;
